<template>
  <svg :class="corIcone"  class="w-6 h-6" fill="currentColor"  stroke-width="2" viewBox="0 0 24 24" style="width: 24px; height: 24px;" xmlns="http://www.w3.org/2000/svg">
    <path :d="pathIcon">
    </path>
  </svg>
</template>

<script>
export default {
  name: "Icone",
  props:{
    pathIcon:{
      type:String,
      required:true
    },
    corIcone:{
      type:String,
      required:false,
      default:"text-gray-50"
    }
  }
}
</script>
